export default __webpack_public_path__ + "static/media/no_image_available.be3b6e8b.png";